module.exports = __webpack_public_path__ + "media/images/front/icons/contents-4d6191ba4ea2c8e1df64d452c992d790.png";